import * as yup from 'yup';

export const validationSchema = yup.object({
  recipientEmail: yup.string().required('Email is required.').email('Must be a valid email.'),
});
